import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import {FeaturesContentCardSmall} from './FeaturesContentCard.small';
import {FeaturesContentCardProps} from './FeaturesContentCard.big';
import {AnimateOnViewWrap} from '../../../wraps';

const Styled = styled.div`
    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }
`;

export interface FeaturesContentCard2UpProps {
    cards?: FeaturesContentCardProps[];
}

export const FeaturesContentCard2Up = ({
    cards = []
}: FeaturesContentCard2UpProps): JSX.Element | null => {
    if (!cards) return null;

    return (
        <Styled>
            <Grid container spacing={8}>
                {cards.map((card, i) => (
                    <Grid item xs={12} md={6} key={card.title || `features-small-${i}`}>
                        <AnimateOnViewWrap translateY={60} delay={0.2 * i}>
                            <FeaturesContentCardSmall {...card} />
                        </AnimateOnViewWrap>
                    </Grid>
                ))}
            </Grid>
        </Styled>
    );
};
